import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import { IPostcardImage } from '../../../infrastructure/interfaces';
import HeaderBar from '../../HeaderBar/HeaderBar';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { contentImagesRelativePath } from '../../../constants';
import {getPostcardImages, createPostcardImage} from "../../../actions/actions";
import PostcardCreatorModal from '../../Modals/PostcardCreatorModal/PostcardCreatorModal';
import {archivePostcardImage} from '../../../actions/actions'

export interface IManagePostcardImagesProps {
    postcardImages?: IPostcardImage[];
    createPostcardImage(iconName: string, postcardSide: string, formData?: FormData): void;
    getPostcardImages(): void;
    archivePostcardImage(postcardImage: IPostcardImage): void;
}

export interface IManagePostcardImagesState {
    showCreateModal: boolean;
    selectedPostcardImage?: IPostcardImage;
    showArchivePostcardModal: boolean;
}

const mapStateToProps = (state: any) => {
    return {
        postcardImages: state.wizard.postcardImages
    };
};

const mapDispatchToProps = (dispatch: any): any => {
    return {
        getPostcardImages: () => {
            dispatch(getPostcardImages());
        },
        createPostcardImage: (iconName: string, postcardSide: string, formData: FormData) => {
            dispatch(createPostcardImage(iconName, postcardSide, formData));
        },
        archivePostcardImage: (postcardImage: IPostcardImage) => {
            dispatch(archivePostcardImage(postcardImage));
          },
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManagePostcardImagesTable extends React.Component<IManagePostcardImagesProps, IManagePostcardImagesState> {
    tableRow: HTMLElement;
    componentDidMount() {
        this.props.getPostcardImages();
    }

    constructor(props: IManagePostcardImagesProps) {
        super(props);
        this.state = {
            showCreateModal: false,
            showArchivePostcardModal: false,
        };
    };

    onEditPostcardImage = (postcardImage: IPostcardImage) => {
        this.setState({
            showCreateModal: true,
            selectedPostcardImage: postcardImage,
            showArchivePostcardModal: false,
        });
    };

    onCreatePostcardImage() {
        this.setState({
            showCreateModal: true,
            showArchivePostcardModal: false,
            selectedPostcardImage: undefined,
        });
    }

    onArchiveRequest(postcardImage: IPostcardImage) {
        this.setState({
            showCreateModal: false,
            showArchivePostcardModal: true,
            selectedPostcardImage: postcardImage
        });
    }

    archivePostcardImage(postcardImage: IPostcardImage) {
        this.props.archivePostcardImage(postcardImage);
    }

    closeModals() {

        this.setState({
            showCreateModal: false,
            showArchivePostcardModal: false,
            selectedPostcardImage: undefined,
        });
    }

    render() {

        const {
            postcardImages,
        } = this.props;
        const nonNullPostcardImages = postcardImages ? postcardImages : [];

        return (
            <div className="root-container">
                <HeaderBar />
                <div className="inner-su-container">
                    <div className="manage-items-row-offsetRight">

                        <div className="in-row-text-container">
                            Manage Postcard Images
                        </div>

                        <div className="in-row-button-container">
                            <button
                                className="btn primary-green large"
                                onClick={() => {this.onCreatePostcardImage();}}
                                title={TooltipCont.CREATE_COVER_PHOTO}
                            >
                                Upload Postcard Image
                            </button>
                        </div>
                    </div>
                    <table className="table-scrollableSU documents-table">
                        <thead style={{ paddingRight: getScrollbarWidth() }}>
                        <tr>
                            <th>Name</th>
                            <th>Side</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="document-table-body">
                        {nonNullPostcardImages.map((s: IPostcardImage) =>
                            <tr key={s.id} ref={tr => this.tableRow = tr!}>
                                <td>
                                    {s.name}
                                </td>
                                <td>
                                    {s.side}
                                </td>
                                <td>
                                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + s.image_src} />
                                </td>
                                <td>
                                    <div className="button-wrapper">
                                    <button
                                        className="btn primary-red"
                                        onClick={() => this.onArchiveRequest(s)}
                                        title={TooltipCont.ARCHIVE}
                                        disabled={false}
                                        >
                                        Archive
                                    </button>
                                    </div>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>

                    <PostcardCreatorModal
                        show={this.state.showCreateModal}
                        onClose={() => this.closeModals()}
                        onSubmit={(iconName: string, postcardSide: string, formData: FormData) => {
                            this.closeModals();
                            this.props.createPostcardImage(iconName, postcardSide, formData);
                        }
                        }
                    />


                    <DeleteConfirmModal
                        show={this.state.showArchivePostcardModal}
                        onClose={() => this.closeModals()}
                        onSave={() => {
                            if(this.state.selectedPostcardImage) {
                                this.archivePostcardImage(this.state.selectedPostcardImage);
                            }
                            this.closeModals();
                        }}
                        title='Are you sure you want to archive this image?'
                    />
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManagePostcardImages.tsx